/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import i18next from 'i18next';
import Campaigns from './containers/Campaigns';
import Updates from './containers/Updates';
import Settings from './containers/Settings';
import ShareCharacter from './containers/ShareCharacter';
import LibraryPage from './containers/LibraryPage';
import AdminPage from './containers/AdminPage';
import HeaderBar from './components/HeaderBar';
import VtmHeaderBar from './vtm/components/VtmHeaderBar';
import VtmLogin from './vtm/components/VtmLogin';
import KofiNudge from './components/KofiNudge';
import SystemPicker from './components/SystemPicker';
import Login from './containers/Login';
import enTranslation from './assets/translation/en.json';
import frTranslation from './assets/translation/fr.json';
import {init} from './utils/initFirebase';
import UserContext from "./context/UserContext";
import SystemContext from "./context/SystemContext";
import {SYSTEMS, detectSystem} from "./utils/gameSystem";
import {loadVtmFonts} from './utils/vtmFonts';
import './index.css';
import './styles/login.css';
import './styles/darkMode.css';
import './styles/vtm/elysium.css';
import './styles/vtm/shared.css';
import Loader from "react-js-loader";

init();
const db = firebase.firestore();
const gameSystem = detectSystem(window.location.hostname, process.env.REACT_APP_GAME_SYSTEM);

const applySystemToDocument = (system) => {
  document.documentElement.setAttribute('data-system', system);
  if (system === SYSTEMS.VTM5) {
    loadVtmFonts();
    document.title = 'Pray the Dice · Vampire';
    document.querySelector('link[rel="icon"]')?.setAttribute('href', `${process.env.PUBLIC_URL}/vtm-favicon.svg`);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#0D0A0B');
  }
};
applySystemToDocument(gameSystem);

const App = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    uid: null,
    displayName: null,
  })

  i18next.init({
    lng: localStorage.getItem('language') || 'fr',
    debug: false,
    resources: {
      en: {
        translation: enTranslation
      },
      fr: {
        translation: frTranslation
      }
    }
  }, function(err, t) {
  });
  
    useEffect( () => {
      getUserId();
    },[]);
  
  const contextValue = {
    user: user,
    updateUser: setUser
  }

    const getUserId = () => {
      setLoading(true);
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          const userJson = {};
          userJson.uid = user.uid;
          userJson.email = user.email;
          userJson.displayName = user.displayName;
          userJson.photoURL = user.photoURL;
          // setUser(userJson);
          getUserDataFirestore(userJson)
        } else {
          setUser({
            uid: null,
            displayName: null,
          });
          setLoading(false);
        }
      });
    }

  const getUserDataFirestore = async (loguser) => {
    await db.collection('users').doc(loguser.uid).set({ lastSeen: new Date() }, { merge: true }).catch(() => {});
    await db.collection('users').doc(loguser.uid).get()
    .then(doc => {
      const mergeUser = {
        ...doc.data(),
        ...loguser
      };
      setUser(mergeUser);
      setLoading(false);
      const element = document.getElementsByTagName('body')[0];
      // VtM a son propre thème sombre : le thème clair/sombre d'Aria ne s'y applique pas
      if (gameSystem !== SYSTEMS.VTM5) {
        element.setAttribute('data-theme', mergeUser.theme);
      }
    })
    .catch(err => {
      console.log(err.messsage)
      setLoading(false);
    })
  }

    return (
    <Router>
      <SystemContext.Provider value={gameSystem}>
      <UserContext.Provider value={contextValue}>
        {loading &&  (
          <div className='loaderContainer'>
            <Loader type="bubble-loop" bgColor={gameSystem === SYSTEMS.VTM5 ? "#9E1B26" : "#ffad23"} size={80} />
          </div>
        )}
        {!loading && (
          <div className={gameSystem === SYSTEMS.VTM5 ? 'vtmApp' : undefined} style={{width: '100%', height: '100%'}}>
            {user && user.uid && (
              <Switch>
                {/* L'accueil Aria (choix du jeu) s'affiche en plein écran, sans barre */}
                {gameSystem !== SYSTEMS.VTM5 && <Route exact path="/" />}
                <Route>
                  {gameSystem === SYSTEMS.VTM5 ? <VtmHeaderBar /> : <HeaderBar />}
                  <KofiNudge />
                </Route>
              </Switch>
            )}
            <Switch>
              <Route path="/campaigns" >
                {!user.uid && (
                  gameSystem === SYSTEMS.VTM5 ? <VtmLogin /> : <Login />
                )}
                {user && user.uid && (
                  <Campaigns />
                )}
              </Route>
              <Route path="/news">
                <Updates />
              </Route>
              <Route path="/settings">
                {user && user.uid && <Settings />}
              </Route>
              <Route path="/library">
                {user && user.uid && <LibraryPage />}
              </Route>
              <Route path="/admin">
                {user && user.uid && <AdminPage />}
              </Route>
              <Route path="/share/:characterUid">
                <ShareCharacter />
              </Route>
              <Route exact path="/">
                {gameSystem === SYSTEMS.VTM5 ? <Redirect to="/campaigns" /> : <SystemPicker />}
              </Route>
            </Switch>
          </div>
        )}
        
      </UserContext.Provider>
      </SystemContext.Provider>
    </Router>
  );
}

export default App